import { render, staticRenderFns } from "./FinacialIncomeGeneratedChart.vue?vue&type=template&id=2a64754f&"
import script from "./FinacialIncomeGeneratedChart.vue?vue&type=script&lang=js&"
export * from "./FinacialIncomeGeneratedChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
installComponents(component, {VCol,VDivider})
